import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_3 = {
  key: 1,
  class: "font-semibold"
}
const _hoisted_4 = {
  key: 2,
  class: "font-semibold"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_7 = {
  key: 1,
  class: "font-semibold"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, " Отправной пункт: ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: "Добавление доп. услуги",
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitSubmitted
  }, {
    default: _withCtx(() => [
      (_ctx.waypoint)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.waypoint.is_endpoint)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Конечный пункт:"))
              : (_ctx.waypoint.number === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Отправной пункт: "))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, "Остановка:")),
            _createTextVNode(" " + _toDisplayString(_ctx.waypoint.city_name), 1)
          ]))
        : (_ctx.stock)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.stock.is_endpoint)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Конечный пункт:"))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, "Остановка:")),
              _createTextVNode(" " + _toDisplayString(_ctx.stock.directionName), 1)
            ]))
          : (_ctx.sender)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createTextVNode(" " + _toDisplayString(_ctx.sender.city), 1)
              ]))
            : _createCommentVNode("", true),
      _createVNode(_component_the_select, {
        disabled: _ctx.loading,
        class: "mt-2",
        placeholder: "Доп. услуга",
        loading: _ctx.data_state.additional_services.is_loading,
        failed: _ctx.data_state.additional_services.is_failed,
        "error-text": "При получении списка доп. услуг произошла ошибка",
        options: _ctx.data_state.additional_services.list,
        "is-invalid": _ctx.state_form$.typeIds.$error,
        "validation-errors": _ctx.state_form$.typeIds.$errors,
        value: _ctx.state.typeIds,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.typeIds) = $event)),
        "search-without-refresh": "",
        multiselect: "",
        onRefresh: _ctx.loadAdditionalServices
      }, null, 8, ["disabled", "loading", "failed", "options", "is-invalid", "validation-errors", "value", "onRefresh"])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}